import React, { useState } from "react";
import PropTypes from "prop-types";
import { Form, Input, Button, Select, message, Upload } from "antd";
import { useFormik } from "formik";
import { isEmpty } from "lodash";
import GiftCreationSchema from "../../../../Schemas/GiftCreationSchema";

import { createGift, updateGift } from "../../../../Services/GiftService";
import { useHistory } from "react-router-dom"; // useHistory for v5

function GiftCreationForm({
  data = {},
  callReFetch,
  isEditMode = false,
  onClose,
}) {
  const formik = useFormik({
    initialValues: {
      name: data.name || "",
      code: data.code || "",
    },
    enableReinitialize: true,
    validationSchema: GiftCreationSchema,
  });

  const [loading, setLoading] = useState(false);
  const history = useHistory(); // useHistory for v5

  const handleSubmit = async () => {
    const values = formik.values;
    if (isEmpty(values.name) || isEmpty(values.code)) {
      message.error("Please insert all required data.");
      return;
    }

    try {
      if (!isEditMode) {
        await createGift(values);
        message.success("Gift created successfully");
        onClose();
        callReFetch();
        formik.resetForm();
        // Redirect to the gift list or wherever you want
      } else {
        const updatedGift = await updateGift(data._id, values);
        callReFetch();
        message.success(
          updatedGift?.data?.message || "Gift updated successfully"
        );
        onClose(); // Close the modal
      }
    } catch (err) {
      console.error("Error: ", err);
      message.error(err?.response?.data?.message || "Something went wrong.");
    }
  };

  const { values } = formik;
  const titleText = isEditMode ? "Gift Detail" : "Create Gift";
  const submitButtonText = isEditMode ? "Update" : "Create";

  return (
    <div>
      <h2
        className="title"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {titleText}
      </h2>
      <p style={{ display: "flex", justifyContent: "center" }}>
        Nama & Code Tidak boleh duplicate
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Form
          layout="vertical"
          style={{
            maxWidth: "80vw",
            backgroundGift: "#F5F5F5",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <Form.Item label="Name" required>
            <Input
              style={{ width: "100%" }}
              placeholder="Enter gift name"
              onChange={(e) => formik.setFieldValue("name", e.target.value)}
              value={values.name}
            />
          </Form.Item>
          <Form.Item label="Code" required>
            <Input
              name="code"
              placeholder="Enter brand code"
              onChange={(e) => {
                const value = e.target.value;

                formik.setFieldValue("code", value);
              }}
              value={formik.values.code}
            />
          </Form.Item>{" "}
          <Form.Item style={{ textAlign: "center" }}>
            <Button
              type="primary"
              htmlType="button"
              className="bg-black"
              onClick={handleSubmit}
              style={{ marginRight: "10px" }}
            >
              {submitButtonText}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

GiftCreationForm.propTypes = {};

export default GiftCreationForm;
